export const postHogOptions = {
  api_host: 'https://eu.i.posthog.com',
  defaults: '2025-11-30',
  capture_exceptions: true,
  capture_pageleave: true,
  autocapture: true,
  rageclick: true,
  cross_subdomain_cookie: false
} as const
